<template>
  <div id="app">
    <!-- <router-link to="/GovernmentServiceHallWeb/">去叫号系统</router-link> -->
    <!-- <router-link to="/GovernmentGuideWeb/">导办</router-link> {{ $store.state.commonData.parent }} -->
    <!-- <GlobalHeader v-show="showHeader"></GlobalHeader> -->
    <!-- <div id="appContainer"></div> -->
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import GlobalHeader from '@/components/page/GlobalHeader'
import { start } from 'qiankun';
export default {
  components: {
    GlobalHeader
  },
  // watch: {
  //   isReLogin (newV, oldV) {
  //     console.log(newV,oldV)
  //     if (!oldV && newV) {
  //       this.$store.dispatch('Logout')
  //       // this.$router.push('/login')
  //     }
  //   },
  // },
  mounted () {
    //在页面加载时读取localStorage里的状态信息
    if (localStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem("store"))))
    }

    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload", () => {
      localStorage.setItem("store", JSON.stringify(this.$store.state))
    })
  },
  computed: {
    ...mapGetters(['isReLogin']),
    ...mapState(["user"]),
    showHeader () {
      return this.user.token
    }
  }
}

</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
